import React, { useMemo } from "react";
import { CONFETTI_COUNT, STAR_PHASE_MS } from "./celebrationTiming";

const CONFETTI_PALETTE = ["#ff6b6b", "#ffd93d", "#6bcb77", "#4d96ff", "#ff922b", "#cc5de8", "#20c997"];

function mulberry32(seed) {
  let state = seed;
  return () => {
    state += 0x6d2b79f5;
    let t = state;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

function buildPieces(count, accentColor, viewportHeight, seed = 42) {
  const rand = mulberry32(seed);
  const fallBase = Math.max(viewportHeight * 1.1, 320);

  return Array.from({ length: count }, (_, i) => {
    const angle = rand() * Math.PI * 2;
    const burst = 36 + rand() * 96;
    const tx = Math.cos(angle) * burst;
    const ty = Math.sin(angle) * burst * 0.55 - (18 + rand() * 28);
    const drift = (rand() - 0.5) * 140;
    const fall = fallBase + rand() * 120;
    const spinStart = rand() * 360;
    const spinEnd = spinStart + (rand() - 0.5) * 900;
    const delay = rand() * 0.14;
    const duration = 1.35 + rand() * 0.85;
    const useAccent = i % 4 === 0 && accentColor;
    const color = useAccent ? accentColor : CONFETTI_PALETTE[Math.floor(rand() * CONFETTI_PALETTE.length)];
    const width = 4 + rand() * 8;
    const height = 3 + rand() * 6;
    const round = rand() > 0.62;

    return {
      id: i,
      tx,
      ty,
      drift,
      fall,
      spinStart,
      spinEnd,
      delay,
      duration,
      color,
      width,
      height,
      round
    };
  });
}

export default function CelebrationConfetti({ left, top, color, viewportHeight = 400 }) {
  const pieces = useMemo(
    () => buildPieces(CONFETTI_COUNT, color, viewportHeight),
    [color, viewportHeight]
  );
  const starPhaseSec = STAR_PHASE_MS / 1000;

  return (
    <div className="lp-confetti-layer" style={{ left, top }} aria-hidden="true">
      {pieces.map((piece) => (
        <span
          key={piece.id}
          className={`lp-confetti-piece${piece.round ? " lp-confetti-round" : ""}`}
          style={{
            "--tx": `${piece.tx}px`,
            "--ty": `${piece.ty}px`,
            "--drift": `${piece.drift}px`,
            "--fall": `${piece.fall}px`,
            "--spin-start": `${piece.spinStart}deg`,
            "--spin-end": `${piece.spinEnd}deg`,
            width: piece.round ? piece.width : piece.width,
            height: piece.round ? piece.width : piece.height,
            backgroundColor: piece.color,
            animationDuration: `${piece.duration}s`,
            animationDelay: `${starPhaseSec + piece.delay}s`
          }}
        />
      ))}
    </div>
  );
}
